import requests from "./httpService";

const NewsServices = {
  getAllnews: async (body) => {
    return requests.get(`/news/getNews`);
  },

  addnews: async (body) => {
    return requests.post(`/news/createNews`, body);
  },
  getnewsByid: async (id) => {
    return requests.get(`/news/getnewsById/${id}`);
  },

  updateNews: async (id, body) => {
    return requests.put(`/news/updatenews/${id}`, body);
  },

  deleteNews: async (id) => {
    return requests.delete(`/news/delete/${id}`);
  },

  updateNewsStatus: async (id, body) => {
    return requests.patch(`/news/updatenewsstatus/${id}`, body);
  }
};

export default NewsServices;
